import React from 'react';
import { getAllKeysFromObject } from '../../utils/flattenJson';
import { DataTable } from '../DataTable';

export default function TableFromJson(params: { json: any , className?: string}) {
  const headers = getAllKeysFromObject(params.json).filter(item => item.indexOf('tableData') === -1);
  const isColumnBool = (title: string) => params.json && params.json[0] && (typeof params.json[0][title] === 'boolean');
  const columns: Array<{title: string, field: string}> = headers.map(title => ({ title, field: title, lookup: isColumnBool(title)? {true: 'True', false: 'False'} : undefined  }) );

  if(!params.json) return null;
  return (
    <DataTable title="Report" columns={columns} data={params.json} options={{exportButton: true, exportAllData: true}} />
  );
}